<template>
    <div>
        <div class="container-fluid">
            <div v-if="loading">
                <PageLoader></PageLoader>
            </div>
            <div class="row mt-3" v-else>
                <div class="col-md-6" v-if="fmbData == null">
                    <div class="safe-card mb-3">
                        <div class="account-btn">
                            <div>
                                <button @click="registrationType = 'new'" class="btn ca" data-toggle="modal" data-target="#createAccount">Create Account</button>
                                <button @click="registrationType = 'old'" class="btn la" data-toggle="modal" data-target="#linkAccount">Link Account</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6" v-else>
                    <div class="safe-card mb-3">
                        <div class="safe-card-top">
                            <div class="" style="display: flex; gap: 10px;">
                                <h3>NHF Wallet</h3>
                            </div>
                            
                        </div>
                        <p class="af">Available funds</p>
                        <div class="safe-amount">
                            <div class>
                                <h3><span class="naira" v-if="amountVisibility">₦</span>{{ amountVisibility ? Number(fmbData.balance).toLocaleString() : '**************'}}  <span @click="amountVisibility = !amountVisibility"><i class="fa" style="cursor: pointer;" :class="[amountVisibility ? 'fa-eye-slash' : 'fa-eye']"></i></span></h3>
                                <p>last funded: <span>{{ '22/2/2026' | moment }}</span></p>
                            </div>
                            <!-- <div>
                                <small class="triggerWithdraw" @click="widthdrawFromSafeTrigger()">Withdraw</small>
                            </div> -->
                        </div>

                        
                    </div>
                </div>
            </div>
            <div class="table-holder">
                <h4  class="t-history">Transaction History</h4>
                <div v-if="transactions.length == 0" class="empty-state mt-5 mb-5">
                    <img src="../../assets/icons/emptycan-state.svg" alt="empty">
                    <h5>No available data</h5>
                </div>
                <div v-else class="table-responsive tableList">
                    <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                        <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Date</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Channel</th>
                                <th scope="col">Reference</th>
                                <th scope="col">Description</th>
                                <th scope="col">Type</th>
                                <th scope="col">Status</th>
                            </tr>
                        </thead>
                        <tbody v-for="(data, index) in transactions" :key="index">
                            <!-- v-for="(item, index) in landlords"
                                :key="index" -->
                            <tr>
                                <td>{{data.date | moment2}}</td>
                                <td>₦{{ Number(data.amount).toLocaleString() }}</td>
                                <td>{{data.channel}} </td>
                                <td>{{data.transaction_reference}}</td>
                                <td>{{data.description}}</td>
                                <td><span :class="[data.type == 'credit' ? 'credit' : 'debit']" class="">{{data.type}}</span></td>
                                <td>{{data.status == 1 ? 'Success' : 'Failed'}}</td>
                            </tr>   
                    
                        </tbody>
                    </table>
                    <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                        <EmptyState :emptyData="emptyDataObject2" />
                    </div> -->
                </div>

            </div>
            <CreateAccount @api-success="fetchFMBData" :reg-type="registrationType" ></CreateAccount>
            <LinkAccount></LinkAccount>
        </div>
    </div>
</template>


<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import CreateAccount from './CreateAccount';
import LinkAccount from './LinkAccount';
import moment from "moment";
import $ from "jquery";
export default {
    name: "nhf-dashboard",
    components: {
        PageLoader,
        CreateAccount,
        LinkAccount
    },

    data() {
        return {
            amountVisibility: false,
            loading: false,
            hideCard: true,
            fmbData: null,
            transactions: [],
            registrationType: "",
        };
    },
    mounted() {
        this.fetchFMBData();
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch((err) => {
            // console.log("none")
            });
        },
        fetchFMBData() {
            this.loading = true;
            Api.getRequest('fetch-fmb-data').then(res => {
                this.loading = false;
                // console.log("FMB DATA:", res)
                if (res.data.data != null) {
                    this.fmbData = res.data;
                    this.transactions = res.data.transactions;
                }
            }).catch((err) => {
            console.log(err)
            this.loading = false;
            });
        }
    },
    filters: {
    moment: function(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    moment2: function(date) {
        return moment(date).format("MMMM Do YYYY");
    },
    moment3: function(date) {
        return moment(date).format("h:mm:ss a");
    },
  }
};
</script>


<style scoped lang="scss">

.account-btn {
    // margin: auto;
    // margin-top: 60px;
    display: grid;
    place-items: center;
    height: 220px;
    button {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        outline: 0;
        box-shadow: none;
    }
    .ca {
        background: #0033EA;
        color: #ffffff;
        margin-right: 6px;
    }
    .la {
        border: 1px solid #0033EA;
        color: #0033EA;
    }
}
.safe-card {
    padding: 16px 25px;
    background: #ffffff;
    border-radius: 12px;
    min-height: 261px;
}

.safe-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    h3 {
        font-family: Lato;
        font-weight: 700;
        font-size: 20px;
        line-height: 160%;
        color: #00155F;
        margin-bottom: 0;
    }
}

.af {
    font-family: Lato;
    font-weight: 500;
    font-size: 15px;
    line-height: 160%;
    color: #374151;
    text-align: left;
    margin-top: 10px;
}

.safe-amount {
    display: flex;
    justify-content: space-between;
    h3, .naira {
        font-family: Lato;
        font-weight: 700;
        font-size: 22px;
        line-height: 32px;
        color: #374151;
        text-align: left;
        span {
            // color: #2BC300;
            font-family: Lato;
            font-weight: 500;
            font-size: 18px;
            line-height: 150%;
            margin-left: 7px;
            cursor: pointer;
        }
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        line-height: 150%;
        color: #555C74;
        text-align: left;
        margin-bottom: 5px;
    }
}

.account-number {
    display: flex;
    gap: 5px;
    text-align: left;
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        // line-height: 22.25px;
        color: #374151;
        margin-bottom: 0;
    }
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        line-height: 22.25px;
        color: #374151;
        margin-bottom: 0;
    }
}

// Empty state
.empty-state {
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 13.95px;
        line-height: 21.7px;
        letter-spacing: 0%;
        text-align: center;
        color: #777777;

    }
}
// empty state

.table-holder {
    background: #ffffff;
    padding: 30px 15px;
    margin-top: 30px;
}
.t-history {
    font-family: Lato;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #2B3352;
    text-align: left;
    margin-bottom: 20px;
}


.tableList {
    // margin-top: 30px;
    margin-bottom: 20px;
    border: 2px solid #EAECF0;
    border-radius: 8px;
}


.table thead th {
    border-bottom: none;
    
}
.table td {
    border-top: 1px solid #EAECF0;
}
.table th {
    border-top: none;
}

thead > tr {
    background: #F3F4F6;
}
thead th {
    white-space: nowrap;
    text-align: left;
    color: #374151;
    font-family: Lato;
    font-weight: 700;
    font-size: 14px;
    line-height: 160%;
}

tbody td {
    padding: 18px .75rem;
    white-space: nowrap;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #374151;
    line-height: 24px;
}

tbody {
    tr {
        cursor: pointer;
    }
}


</style>